/**
 * Created by Timur on 27.07.2026
 */

(function () {
    const original = MissionsTool.getMissionMenu;

    MissionsTool.getMissionMenu = function (mission) {
        const actions = original.call(this, mission);
        if (mission.type !== Mission.TYPE_BALLOON_RISE) {
            return actions;
        }

        actions.openStartWindow = displayToolWindow(() => new BalloonRiseStartWindow(mission));
        actions.openWindow = displayToolWindow(() => new BalloonRiseWindow(mission));
        actions.openFinishWindow = displayToolWindow(() => new BalloonRiseFinishWindow(mission));

        actions.completeStage = () => {
            const logic = mission.logic;
            const stage = logic.getCurrentStage();
            if (!stage) {
                return;
            }

            if (!logic.isUnlocked()) {
                logic.startCompetition();
            }

            const need = stage.goal - logic.level;
            if (need > 0) {
                logic.incLevel(need);
            }
        };

        actions.startExtraChallenge = () => {
            const logic = mission.logic;
            if (!logic.isUnlocked()) {
                logic.startCompetition();
            }

            logic.level = 0;
            logic.stage = logic.regularStagesCount;
            logic.update();
        };

        actions.lose = () => {
            mission.logic.showLoseWindow();
        };

        actions.spendEnergy = () => {
            if (!mission.logic.isUnlocked()) {
                mission.logic.startCompetition();
            }

            cleverapps.eventBus.trigger("spendEnergy", 10);
        };

        actions.expireLoseTimer = () => {
            if (!mission.logic.isUnlocked()) {
                mission.logic.startCompetition();
            }

            BalloonRiseMerge2Adapter.createTimer(mission, Date.now() - BalloonRiseLoseTimer.LOSE_TIMEOUT - 1000);
        };

        actions.resetLoseTimer = () => {
            BalloonRiseMerge2Adapter.destroyTimer();
        };

        actions.logLoseTimerStatus = () => {
            const timer = BalloonRiseMerge2Adapter.timer;
            console.log("BalloonRise lose timer", {
                active: Boolean(timer),
                timeLeft: cleverapps.intervalToString(timer ? timer.getTimeLeft() : 0)
            });
        };

        return actions;
    };
}());
